import React, { FC, useMemo } from "react";
import { FlatList, StyleProp, ViewStyle } from "react-native";
import { Divider } from "@lookiero/aurora";
import { Text } from "@lookiero/sty-psp-ui";
import { ProductVariant } from "../../../../../../domain/projections/Wishlist";
import { WishlistItem } from "../wishlistItem/WishlistItem";
import { style as wishlistProductListStyle } from "./WishlistProductList.styles";

interface WishlistProductListProps {
  readonly products: ProductVariant[];
  readonly title?: string;
  readonly rounded?: boolean;
  readonly style?: StyleProp<ViewStyle>;
  readonly unavailable?: boolean;
  readonly onDeleteFromWishlist: (variantId: string) => void;
  readonly onAddToBasket: (variantId: string) => void;
}

const WishlistProductList: FC<WishlistProductListProps> = ({
  products,
  title,
  rounded = false,
  style: customStyle,
  unavailable = false,
  onDeleteFromWishlist,
  onAddToBasket,
}) => {
  const style = useMemo(() => wishlistProductListStyle(), []);

  return products && products.length > 0 ? (
    <FlatList
      ItemSeparatorComponent={() => <Divider style={style.separator} />}
      data={products}
      keyExtractor={(productVariant) => productVariant.variantId}
      style={[style.list, rounded ? style.rounded : undefined, customStyle]}
      testID="wishlist-list"
      ListHeaderComponent={() =>
        title ? (
          <Text level={3} style={style.title} testID="list-title" variant="action">
            {title}
          </Text>
        ) : null
      }
      renderItem={({ item: productVariant }) => {
        return (
          <WishlistItem
            available={!unavailable}
            productVariant={productVariant}
            onAddToBasket={onAddToBasket}
            onDelete={onDeleteFromWishlist}
          />
        );
      }}
    />
  ) : null;
};

export { WishlistProductList };
